const values = {
    INTRO_MODULE_ID: 'intro',
    PROGRESS_BAR_ANIMATION_DURATION: 500,
    MODULE_NAMESPACE: 'scripts/modules',
    CONTENT_NAMESPACE: 'content',
    HASH_HISTORY_LIMIT: 50,
    PLAN_DETAILS_CONTENT_NAME: 'plan-details',
    TALENTSHOW_DIRECTORY: 'content/schism-slideshow/data',
    FLASH_JSAPI: 'window.ALEX.API.FlashInterface.flashAction',
    TALENTSHOW_RUNTIME_NAMESPACE: 'schism-slideshow',
    RUNTIME_CDN_DIR: 'talentshow-runtime',
    KENTICO_PREVIEW_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3Y2JjZmFjMGNjNjc0N2MyODA4YWQ3ZGMxNjU4ZjMxNCIsImlhdCI6MTczOTgwOTM4NywibmJmIjoxNzM5ODA5Mzg3LCJleHAiOjE4OTM1MTQ5MjAsInZlciI6IjIuMC4wIiwic2NvcGVfaWQiOiI4MTgxZmVjNzI5NTg0ODE0OGUyMmY5ZWUxOWI0MWUxMyIsInByb2plY3RfY29udGFpbmVyX2lkIjoiNGMxYWVjYWExYzdlMDA1ZDg0MmU0OTMwNWUwZDRjNDQiLCJhdWQiOiJkZWxpdmVyLmtvbnRlbnQuYWkifQ.FETl51T2p38xVroQ4EoZDbrMOxo1IfNeOmm47Asw1oA',
    KENTICO_ENVIRONMENT_ID: '831b591e-b12f-007a-2617-a35180c56dda',
};
export default values;
//# sourceMappingURL=constant.js.map